module.exports = __webpack_public_path__ + "img/smoke6.ad4e99f0.png";